import Vue from 'vue'
import AppNsuk from './App.vue'
import vuetifyNsuk from '../plugins/vuetify'
import store from './store'
import router from './routes'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
//import 'vue-toast-notification/dist/theme-default.css';
import axios from 'axios';
import NotificationPlugin from '../plugins/notify';
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import urlUtil from "@/utils/urlUtil";

// set default api
axios.defaults.baseURL = urlUtil.getBaseUrl();


Vue.config.productionTip = false
Vue.use(NotificationPlugin)
Vue.use(VueToast);

new Vue({
    store,
    vuetify: vuetifyNsuk,
    router,
    render: h => h(AppNsuk)
}).$mount('#app')
